'use client';
import React from 'react';
import Link from 'next/link';
import { X, Coffee, Heart, Bookmark, MessageCircle } from 'lucide-react';

interface AuthGateModalProps {
  isOpen: boolean;
  onClose: () => void;
  action?: string;
}

export default function AuthGateModal({ isOpen, onClose, action = 'fitur ini' }: AuthGateModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay animate-fade-in" onClick={onClose}>
      <div className="modal-content animate-scale-in" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-muted transition-colors">
          <X size={18} className="text-muted-foreground" />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Coffee size={28} className="text-primary" />
          </div>
          <h2 className="text-xl font-800 text-primary mb-2">Login dulu, yuk!</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Kamu perlu login untuk {action}. Gabung Nongki dan temukan tempat nongkrong terbaik bareng komunitas!
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-6">
          {[
            { icon: Heart, text: 'Like dan comment review tempat favorit' },
            { icon: Bookmark, text: 'Simpan cafe ke koleksi pribadi' },
            { icon: MessageCircle, text: 'Ikut Nongkrong Bareng events' },
          ].map((item, i) => (
            <div key={`benefit-${i}`} className="flex items-center gap-3 p-3 bg-secondary rounded-xl">
              <item.icon size={16} className="text-accent flex-shrink-0" />
              <span className="text-sm text-foreground">{item.text}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <Link href="/sign-up-login-screen" className="btn-primary w-full">
            Masuk Sekarang
          </Link>
          <Link href="/sign-up-login-screen" className="btn-secondary w-full">
            Buat Akun Baru
          </Link>
        </div>
      </div>
    </div>
  );
}